import {Get, getUrl, Post, Put} from "@/services/customer-support/index";

export const List = async (body) => {
  return Post(getUrl('cnps.css.assign-order.search'), body);
}

export const Detail = async (id) => {
  return Get(getUrl('cnps.css.assign-order.get', { id }));
}

export const Cancel = async (id) => {
  return Post(getUrl('cnps.css.assign-order.cancel', {id}));
}

// status: APPROVED or REJECTED
export const Approve = async (body) => {
  return Post(getUrl('cnps.css.assign-order.approve'), body);
}

// status: APPROVED or REJECTED or CANCELED
export const Overdue = async (body) => {
  return Post(getUrl('cnps.css.assign-order.approve-overdue'), body);
}

export const Remove = async (body) => {
  return Post(getUrl('cnps.css.remove-staff-assign-for-one'), body);
}

export const RemoveMany = async (body) => {
  return Post(getUrl('cnps.css.remove-staff-assign-for-many'), body);
}
